<div>
  <button
    (click)="autoFill()"
    class="vs-tertiary-btn auto-fill-btn">
    <span>{{ "quoteCheckout.autoFillBtn" | cxTranslate }}</span>
  </button>
</div>
<br>
<div [formGroup]="exportComplianceForm" *ngIf="allQuestions$ | async">
  <!--Questions-->
  <div
    *ngFor="
      let question of allQuestions.vsExportComplianceQuestions;
      let i = index
    "
  >
    <span class="question-text">{{ i + 1 }} . </span
    ><span [innerHTML]="question?.question" class="question-text"></span>
    <div
      class="vs-radio-button row question"
      id="{{ question.questionId }}Error"
    >
      <input
        id="{{ question.questionId }}-radio"
        type="radio"
        [value]="true"
        [name]="question.questionId"
        [formControlName]="question.questionId"
        (change)="setValue(question.questionId, true)"
      />
      <label class="radio-text" for="{{ question.questionId }}-radio">
        {{ "quoteCheckout.radioYes" | cxTranslate }}
      </label>

      <input
        id="no-{{ question.questionId }}-radio"
        type="radio"
        [value]="false"
        [name]="question.questionId"
        [formControlName]="question.questionId"
        (change)="setValue(question.questionId, false)"
      />
      <label for="no-{{ question.questionId }}-radio" class="ml-3"> {{ "quoteCheckout.radioNo" | cxTranslate }} </label>
    </div>
    <label
      class="error"
      *ngIf="
        isSubmitted &&
        this.exportComplianceForm.controls[question.questionId].invalid
      "
      >{{ "quoteCheckout.error" | cxTranslate }} 
    </label>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        question.questionId == 'sanctionCheck'
      "
      class="complience-error"
    >
    <p class="order-paragraph">
      <i class="material-icons">report</i><strong> {{ "quoteCheckout.errorWord" | cxTranslate }} </strong>
      <span class="error-text">
         {{ "quoteCheckout.errMsg" | cxTranslate }}
      </span>
    </p> 
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        (question.questionId == 'restrictedPartList')
      "
      class="complience-warning"
    >
      <i class="material-icons">warning</i><strong> {{ "quoteCheckout.warning" | cxTranslate }} </strong>
      <span class="error-text">
        {{ "quoteCheckout.complienceWarning" | cxTranslate }} 
      </span>
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        (          question.questionId == 'governmentParties')
      "
      class="complience-warning"
    >
      <i class="material-icons">warning</i><strong> {{ "quoteCheckout.warning" | cxTranslate }}  </strong>
      <span class="error-text">
        {{ "quoteCheckout.complienceWarning2" | cxTranslate }}
      </span>
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        question.questionId == 'warningFlags'
      "
      class=""
    >
      <div class="warning-textarea-text">
        <span class="error">*</span>
        {{ "quoteCheckout.warningText" | cxTranslate }}
      </div>
      <textarea
        [(ngModel)]="warningFlagText"
        maxlength="250"
        class="warning-textarea"
        rows="4"
        (input)="warningFlagTextChange()"
        [ngModelOptions]="{ standalone: true }"
      ></textarea>
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        question.questionId == 'hasRestrictedUse'
      "
      class="complience-warning"
    >
      <i class="material-icons">warning</i><strong> {{ "quoteCheckout.warning" | cxTranslate }} </strong>
      <span class="error-text">
        {{ "quoteCheckout.complienceWarning3" | cxTranslate }}
        </span
      >
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        question.questionId == 'requiresExportLicense'
      "
      class="complience-warning"
    >
      <i class="material-icons">warning</i><strong> {{ "quoteCheckout.warning" | cxTranslate }} </strong>
      <span class="error-text">
        {{ "quoteCheckout.complienceWarning4" | cxTranslate }} 
        </span
      >
    </div>
    <div
      *ngIf="
        (this.exportComplianceForm.controls[question.questionId]?.value ==
          true ||
          this.exportComplianceForm.controls[question.questionId]?.value ==
            'true') &&
        question.questionId == 'governmentParties'
      "
      class="complience-warning"
    >
      <i class="material-icons">warning</i><strong> {{ "quoteCheckout.warning" | cxTranslate }} </strong>
      <span class="error-text">
        {{ "quoteCheckout.complienceWarning5" | cxTranslate }} 
        </span
      >
    </div>
  </div>
</div>
